import { Heading } from '@chakra-ui/react';
import { PaymentMethodSummaryResponse } from '@monetize/types/app';
import { MBox, MText, MVStack } from '../../../components/Monetize';
import { PaymentMethodTypeEnumDisplay } from '../../../constants/paymentMethods';
import {
  AllowedPaymentMethods,
  QuoteShareUxConfig,
} from '../useQuoteShareData';

interface QuoteSharePaymentMethodProps {
  paymentMethods: PaymentMethodSummaryResponse[];
  selectedPaymentMethodId?: string | null;
  paymentType: 'ELECTRONIC' | 'ACH';
  quoteShareUxConfig: QuoteShareUxConfig;
}

export const QuoteSharePaymentMethod = ({
  paymentMethods,
  selectedPaymentMethodId,
  paymentType,
  quoteShareUxConfig,
}: QuoteSharePaymentMethodProps) => {
  const selectedMethod = selectedPaymentMethodId
    ? paymentMethods.find(({ id }) => id === selectedPaymentMethodId)
    : null;

  if (
    paymentType === 'ACH' &&
    (quoteShareUxConfig.allowedPaymentMethods ===
      AllowedPaymentMethods.ACH_WIRE_TRANSFER ||
      quoteShareUxConfig.allowedPaymentMethods ===
        AllowedPaymentMethods.ELECTRONIC_AND_ACH) &&
    quoteShareUxConfig.achContent
  ) {
    return (
      <>
        <MText>
          To pay via ACH, transfer funds using the following bank information.
        </MText>
        <MBox
          className="rich-text"
          dangerouslySetInnerHTML={{
            __html: quoteShareUxConfig.achContent,
          }}
        />
      </>
    );
  }

  if (!selectedMethod) {
    return (
      <MBox>
        <MText color="tOrange.base" fontWeight={500}>
          Please provide a payment method to continue.
        </MText>
      </MBox>
    );
  }

  const description = [
    selectedMethod.creditCardType ||
      PaymentMethodTypeEnumDisplay[selectedMethod.paymentMethodType],
    selectedMethod.lastFour ? `ending in ${selectedMethod.lastFour}` : null,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <MBox>
      <MVStack alignItems="flex-start" gap="0.2rem" my="0.8rem">
        <Heading as="h3" fontSize="sm" fontWeight="500">
          {PaymentMethodTypeEnumDisplay[selectedMethod.paymentMethodType]}
        </Heading>
        <MText lineClamp={1}>{description}</MText>
      </MVStack>
    </MBox>
  );
};
